import React from 'react';
import { PencilIcon, TrashIcon, DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '@/state/language/LanguageProvider';

interface HierarchyNode {
  id: string;
  name: string;
  level_type: string;
  level: number;
  parent_id?: string;
  status: string;
  children?: HierarchyNode[];
  expanded?: boolean;
}

interface HierarchyNodeActionsProps {
  node: HierarchyNode;
  onEdit: (node: HierarchyNode) => void;
  onDelete: (node: HierarchyNode) => void;
  onCopy: (node: HierarchyNode) => void;
}

export const HierarchyNodeActions: React.FC<HierarchyNodeActionsProps> = ({
  node,
  onEdit,
  onDelete,
  onCopy,
}) => {
  const { t } = useLanguage();

  return (
    <div className="flex items-center space-x-1">
      <button
        onClick={() => onEdit(node)}
        className="p-1 hover:bg-gray-200 rounded text-gray-600"
        title={t('common.edit')}
      >
        <PencilIcon className="h-4 w-4" />
      </button>
      <button
        onClick={() => onCopy(node)}
        className="p-1 hover:bg-blue-50 rounded text-blue-600"
        title="Copy"
      >
        <DocumentDuplicateIcon className="h-4 w-4" />
      </button>
      <button
        onClick={() => onDelete(node)}
        className="p-1 text-red-600 hover:bg-red-50 rounded"
        title={t('common.delete')}
      >
        <TrashIcon className="h-4 w-4" />
      </button>
    </div>
  );
};
